import { parseFromStripe } from "./parseFromStripe";

const fromStripe = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 9350,
    amount_paid: 0,
    amount_remaining: 9350,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "subscription_create",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695571200,
    currency: "myr",
    custom_fields: null,
    customer: null,
    customer_address: null,
    customer_email: null,
    customer_name: null,
    customer_phone: null,
    customer_shipping: null,
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_1ef02cGSTSE9ZxBoa8af7683",
                object: "line_item",
                amount: 5900,
                amount_excluding_tax: 5900,
                currency: "myr",
                description: "1 × Subscription (Monthly) (at RM59.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698163200,
                    start: 1695571200,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 5900,
                    amount_decimal: "5900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "inclusive",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 5900,
                    unit_amount_decimal: "5900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1Nq7VGGSTSE9ZxBoef4aW8Hh",
                subscription_item: "si_OdOHTwgrk7je0J",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "5900",
            },
            {
                id: "il_tmp_1c2c5fGSTSE9ZxBo17273b77",
                object: "line_item",
                amount: 1380,
                amount_excluding_tax: 1380,
                currency: "myr",
                description: "2 × User Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698163200,
                    start: 1695571200,
                },
                plan: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 2,
                subscription: "sub_1Nq7VGGSTSE9ZxBoef4aW8Hh",
                subscription_item: "si_OdOHZk6hGHMeuq",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_1c25afGSTSE9ZxBo4e285c78",
                object: "line_item",
                amount: 2070,
                amount_excluding_tax: 2070,
                currency: "myr",
                description: "3 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698163200,
                    start: 1695571200,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 3,
                subscription: "sub_1Nq7VGGSTSE9ZxBoef4aW8Hh",
                subscription_item: "si_OdOH1EPFYzzlmC",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
        ],
        has_more: false,
        total_count: 3,
        url: "/v1/invoices/upcoming/lines?currency=myr&subscription_items%5B0%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBol7EKURyb&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bdeleted%5D=false&subscription_items%5B1%5D%5Bprice%5D=price_1Nhl5dGSTSE9ZxBorBEVOhba&subscription_items%5B1%5D%5Bquantity%5D=2&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&subscription_items%5B2%5D%5Bquantity%5D=3&subscription_items%5B2%5D%5Bdeleted%5D=false&subscription_start_date=1695571200",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695571200,
    period_start: 1695571200,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1Nq7VGGSTSE9ZxBoef4aW8Hh",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1695571200,
    subtotal: 9350,
    subtotal_excluding_tax: 9350,
    tax: null,
    test_clock: null,
    total: 9350,
    total_discount_amounts: [],
    total_excluding_tax: 9350,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

export const NewSubscriptionExpected = {
    invoice_preview: parseFromStripe(fromStripe),
};

// export const SameCycleUpgradePreviewInvoice = {
//     subtotal: 46.24,
//     discount_amount: 0,
//     total_excluding_tax: 46.24,
//     tax_amount: 2.78,
//     total: 49.02,
//     amount_due: 49.02,
//     billing_cycle: 1, // from recurring.interval_count
//     // billing_anchor_date: '2023-09-11 00:00:00',
//     proration_start_date: '2023-09-11 00:00:00', // from lines.data.start_date
//     proration_end_date: '2023-09-29 16:33:36', // from lines.data.end_date
//     first_billing_date: '2023-09-11 00:00:00', // from created (try with always_invoice vs create_prorations)
//     prices: [
//         {
//             description: "Unused time on Subscription (Monthly) after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 59,
//             amount: -35.57,
//             amount_excluding_tax: -35.57,
//             product_name: "Growth",
//         },
//         {
//             description: "Remaining time on Data Extraction Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 14.9,
//             amount: 8.98,
//             amount_excluding_tax: 8.98,
//             product_name: "Data Extraction Top Up",
//         },
//         {
//             description: "Remaining time on WhatsApp File Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 14.9,
//             amount: 8.98,
//             amount_excluding_tax: 8.98,
//             product_name: "WhatsApp File Top Up",
//         },
//         {
//             description: "Remaining time on Email Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 6.9,
//             amount: 4.16,
//             amount_excluding_tax: 4.16,
//             product_name: "Email Top Up",
//         },
//         {
//             description: "Remaining time on Subscription (Monthly) after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 99,
//             amount: 59.69,
//             amount_excluding_tax: 59.69,
//             product_name: "Premium",
//         },
//     ],
// };
